import {LOGIN,LOADING,LOGOUT} from './actionTypes';

const initialState = {
    userinfo:{},
    loading: false,
    cartItems:[]
};

export const MainReducer = (state = initialState, action)=> {
    switch (action.type){
        case LOGIN:
            return {
                ...state,userinfo:action.payload
            }
        case LOGOUT:
            return {
                ...state,userinfo:[]
            }
        case LOADING:
            return {
                ...state,loading:action.payload
            }
        case 'CARTITEMS':
            return {
                ...state,cartItems:action.payload
            }
        default:
            return state;
    }
}